import { api } from '@/global/services/api'
import { isObject } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import documentsHistoryHelper from '../documents-history-helper'
import { notify } from '@/global/services/notification/notificationBus'
import tabsHelper from '../tabs-helper'

const DOCUMENTS_HISTORY_DATA_KEY = 'inspectionDocuments'
const DOCUMENT_TYPE = 'scene_investigation_report'
export default {

  mixins: [
    documentsHistoryHelper,
    tabsHelper
  ],

  data () {
    return {
      inspectionReportHistoryVisible: false,
      inspectionReportShowEditButtons: false,
      inspectionReportEditState: false,
      inspectionReportShowDocumentPreview: false,
      inspectionReportDocument: null,
      inspectionReportDataForGenerationVisible: true,
      inspectionReportTitle: this.$t('road-maintenance/aggregator.on_site_inspection_report'),
      inspectionReportBaseTitle: this.$t('road-maintenance/aggregator.on_site_inspection_report'),
      inspectionReportValidationErrors: {},
      inspectionDocumentHistoryLoaded: false,
      inspectionRefreshDisabled: false,
      irDocumentLoaders: [],
      showIrTabLoader: null
    }
  },

  computed: {
    inspectionReportConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.on_site_inspection_report'),
        visible: this.$route.query.category !== 'request_new',
        key: 'inspection-report',
        validationErrors: this.inspectionReportValidationErrors,
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}/store`,
            usePatch: false,
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`,
            method: 'get'
          }
        },
        edit: this.inspectionReportEditState,
        editUpdate: (event) => this.onInspectionReportEditUpdate(event),
        dataFetched: (event) => this.onInspectionReportDataFetched(event),
        afterCancel: (event) => this.onInspectionReportDataFetched(event),
        afterSave: (event) => this.onInspectionReportDataFetched(event, true),
        modifyDataBeforeSend: (event) => this.onInspectionModifyData(event),
        showLoader: this.showIrTabLoader,
        hiddenFormKeys: [
          'html'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.inspectionReportTitle,
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            forceAdditionalButtonsDisplay: true,
            showEditButtons: this.inspectionReportShowEditButtons,
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                visible: !this.inspectionReportShowEditButtons,
                disabled: this.inspectionRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  this.inspectionRefreshDisabled = true

                  await fetchTabData?.()
                  await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

                  setTimeout(() => {
                    this.inspectionRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('road-maintenance/aggregator.upload_document'),
                prependIcon: 'mdi-upload',
                visible: !this.inspectionReportShowEditButtons && !!this.permissions?.canImportDocument,
                click: (event) => this.onUploadDocument(event)
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: !this.inspectionReportShowEditButtons && !!this.permissions?.canChangeStatus,
                click: (event) => this.onChangeStatus(event)
              },
              {
                type: 'dropdown',
                buttonType: 'base',
                label: this.$t('road-maintenance/aggregator.generate_document'),
                color: '#65AD45',
                class: 'generate-document-btn',
                visible: !this.inspectionReportShowEditButtons && !!this.permissions?.canCreate,
                menuContentClass: 'menu-class',
                component: this.documentsGenerationDropdownMenuComponent,
                hasHistoryData: this.logsData?.[DOCUMENTS_HISTORY_DATA_KEY]?.length,
                menuItemClick: (event) => this.inspectionMenuItemClick(event)
              },
              {
                type: 'base',
                label: this.viewPdfBtnLabel,
                color: '#6e736d',
                visible: this.inspectionReportShowEditButtons,
                class: 'generate-document-btn',
                loaderConfig: {
                  opacity: 0,
                  color: '#FFFFFFF'
                },
                showLoader: this.showPreviewLoader,
                click: (event) => this.previewDocument(event, DOCUMENT_TYPE, this.inspectionReportBaseTitle)
              }
            ],
            onCancelTabSave: () => this.onInspectionReportCancelTab(),
            onSaveClick: (event) => this.onInspectionSave(event)
          },
          // Data for document generation
          {
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.data_for_document_generation'),
            visible: this.inspectionReportDataForGenerationVisible,
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'doc_class',
                    label: this.$t('road-maintenance/aggregator.class'),
                    row: 1,
                    column: 1,
                    colSpan: 1,
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'registry_number',
                    row: 1,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.registration_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'created_at',
                    type: 'datetime-picker',
                    subType: 'date',
                    row: 1,
                    column: 3,
                    colSpan: 1,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.date,
                    placeholder: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.document_date'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          created_at: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'applicant',
                    row: 2,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/prp.request_applicant'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'addresses',
                    row: 2,
                    column: 2,
                    colSpan: 2,
                    label: this.$t('road-maintenance/aggregator.request_locations'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'work_type',
                    type: 'textarea',
                    row: 3,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.type_of_works_or_actions'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'regulation_setter',
                    row: 3,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/codebook_type.regulation_setter'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_name',
                    row: 3,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_name'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible',
                    row: 4,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_phone',
                    row: 4,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_phone'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_email',
                    row: 4,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_email'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.requested_date_from_request'),
                    row: 5,
                    column: 1,
                    colSpan: 2,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    key: 'date_time_from',
                    row: 6,
                    column: 1,
                    colSpan: 1.5,
                    appendIcon: 'mdi-calendar-month',
                    label: this.$t('road-maintenance/aggregator.date_from'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'date_time_to',
                    row: 6,
                    column: 2,
                    colSpan: 1.5,
                    appendIcon: 'mdi-calendar-month',
                    label: this.$t('road-maintenance/aggregator.date_to'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'other_participants',
                    type: 'textarea',
                    row: 7,
                    column: 1,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.other_participants'),
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'report_text',
                    type: 'textarea',
                    row: 7,
                    column: 2,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.report_text'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  },
                  {
                    key: 'report_note_1',
                    type: 'textarea',
                    row: 8,
                    column: 1,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.reports_additions_one'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  },
                  {
                    key: 'report_note_2',
                    type: 'textarea',
                    row: 8,
                    column: 2,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.reports_additions_two'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  }
                ]
              }
            ]
          },
          // document history
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.log_history'),
            visible: this.inspectionReportHistoryVisible,
            externalData: this.logsData,
            dataKey: DOCUMENTS_HISTORY_DATA_KEY,
            columnsConfig: [
              {
                key: 'created_at',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.date') + ':',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.datetimeShort) : ''
                }
              },
              {
                key: 'status',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/excavation-service.status') + ':',
                customValue: (data) => {
                  return data?.status ? this.$t(data.status) : '-'
                }
              },
              {
                key: 'user',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.user') + ':'
              },
              {
                key: 'document',
                valueClass: 'history-block-value',
                visible: (event) => {
                  return event?.blockValue !== '-'
                },
                loaderIds: this.irDocumentLoaders,
                title: this.$t('road-maintenance/aggregator.document') + ':',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                customValue: (data) => {
                  return data?.document?.name ? data.document.name : '-'
                },
                click: (event) => this.onIrDownloadDocument(event)
              },
              {
                visible: (event) => {
                  return !!event?.rowData?.document_data_id
                },
                component: this.createFromVersionBtnComponent,
                class: 'create-from-version-btn-block',
                onClick: (event) => this.onIrCreateFromVersion(event)
              }
            ]
          },
          // document preview
          {
            component: this.documentPreviewComponent,
            visible: this.inspectionReportShowDocumentPreview,
            content: this.inspectionReportDocument
          }
        ]
      }
    }
  },

  methods: {
    async onIrDownloadDocument (event) {
      const { id: documentId } = event?.rowData || {}
      // skip if download is already in progress
      if (this.irDocumentLoaders.includes(documentId)) {
        return
      }
      // show document loader
      if (documentId && !this.irDocumentLoaders.includes(documentId)) {
        this.irDocumentLoaders.push(documentId)
      }

      // download document
      await this.downloadDocument(event)
      // stop document loader
      if (this.irDocumentLoaders.includes(documentId)) {
        this.irDocumentLoaders = this.irDocumentLoaders.filter(activeLoaderId => activeLoaderId !== documentId)
      }
    },

    async onInspectionReportGenerateDocument (event, showLast = false) {
      try {
        const { formData } = event || {}
        const { id } = this?.$route?.params || {}
        this.showIrTabLoader = true

        // validate data
        if (!id) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Missing traffic regulation id')
          return
        }
        if (!isObject(formData)) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Form data is invalid', formData)
          return
        }

        if (formData) {
          // Create formData object for sending
          const dataToSend = new FormData()
          dataToSend.append('other_participants', formData?.other_participants ?? '')
          dataToSend.append('report_text', formData?.report_text ?? '')
          dataToSend.append('report_note_1', formData?.report_note_1 ?? '')
          dataToSend.append('report_note_2', formData?.report_note_2 ?? '')
          dataToSend.append('show_last_version', showLast)
          dataToSend.append('created_at', formData?.created_at ? dateService.formatCustom(formData.created_at, FORMATS.date, FORMATS.isoDate) : '')

          // Get document html
          const { data } = await api('road-maintenance').post(`traffic-regulation/${id}/${DOCUMENT_TYPE}`, dataToSend)

          this.inspectionReportDocument = data
          this.inspectionReportShowDocumentPreview = true
          this.inspectionReportEditState = true
          this.inspectionReportShowEditButtons = true
          this.inspectionReportDataForGenerationVisible = false
          this.inspectionReportTitle = this.$t('road-maintenance/aggregator.inspection_report_document_overview')
        }
      }
      catch (exception) {
        const { errors } = exception?.response?.data || {}
        this.inspectionReportValidationErrors = errors && isObject(errors) ? errors : {}
        console.error(exception)
      }
      finally {
        this.showIrTabLoader = false
      }
    },

    async onIrCreateFromVersion (event) {
      try {
        this.showIrTabLoader = true

        // get document data
        const data = await this.createFromVersion(event, DOCUMENT_TYPE)

        const { html, css } = data || {}
        // do not open document if data is invalid
        if (!html && !css) {
          return
        }

        // set document data and open document preview
        this.inspectionReportDocument = data
        this.inspectionReportShowDocumentPreview = true
        this.inspectionReportEditState = true
        this.inspectionReportShowEditButtons = true
        this.inspectionReportDataForGenerationVisible = false
        this.inspectionReportTitle = this.$t('road-maintenance/aggregator.inspection_report_document_overview')
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showIrTabLoader = false
      }
    },

    onInspectionReportCancelTab () {
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.data_not_saved_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.inspectionCancel())
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    inspectionCancel () {
      this.inspectionReportEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
    },

    onInspectionSave (event) {
      const { saveTab } = event || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('road-maintenance/aggregator.document_will_be_uploaded_to_centrix_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.onInspectionSaveConfirmation(saveTab))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    onInspectionSaveConfirmation (saveTabFn) {
      if (typeof saveTabFn === 'function') {
        saveTabFn()
      }

      this.inspectionReportEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
      this.$set(this.informationDialogConfig, 'title', this.informationDialogBaseConfig.title)
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', this.informationDialogBaseConfig.confirmCallbackFunction)
    },

    onInspectionReportEditUpdate (event) {
      const { edit } = event || {}
      this.inspectionReportHistoryVisible = !edit

      if (!edit) {
        this.inspectionReportShowDocumentPreview = false
        this.inspectionReportEditState = false
        this.inspectionReportShowEditButtons = false
        this.inspectionReportDataForGenerationVisible = true
        this.inspectionReportDocument = null
        this.inspectionReportTitle = this.inspectionReportBaseTitle
      }
    },

    async onInspectionReportDataFetched (event, afterSave = false) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Update contractor
          contractor_name: data?.contractor?.name ?? null,
          contractor_responsible: data?.contractor?.responsible_person ?? null,
          contractor_phone: data?.contractor?.phone ?? null,
          contractor_email: data?.contractor?.email ?? null,
          created_at: data?.created_at && !dateService.isValid(data.created_at, FORMATS.date, true) ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.date) : dateService.now(FORMATS.date),

          // Regulation setter
          regulation_setter: data?.regulation_setter?.description ? this.$t(data.regulation_setter.description) : null,

          // datetime from and to
          date_time_from: data?.date_time_from ? dateService.formatCustom(data.date_time_from, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          date_time_to: data?.date_time_to ? dateService.formatCustom(data.date_time_to, FORMATS.isoDatetime, FORMATS.datetimeShort) : null
        })
      }

      if (!this.inspectionDocumentHistoryLoaded || afterSave) {
        this.inspectionDocumentHistoryLoaded = true
        const { id: suggestedStatusId, description } = data?.suggested_status || {}

        // Fetch documents logs
        await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

        // Open change status popup after documents save only if we have suggested status provided
        if (suggestedStatusId) {
          this.$set(this.afterDocumentStatusChangeActions, 'statusId', suggestedStatusId)
          const message = this.$t('road-maintenance/aggregator.status_change_message')
          this.$set(this.informationDialogConfig, 'showDialog', afterSave)
          this.$set(this.informationDialogConfig, 'message', '<div> ' + message + '<span style="font-style: italic; color: green;">' + ' ' + this.$t(description) + '</span>?</div>')
        }
      }
    },

    onInspectionModifyData (event) {
      const { originalData } = event || {}

      if (originalData) {
        originalData.created_at = originalData?.created_at ? dateService.formatCustom(originalData.created_at, FORMATS.date, FORMATS.isoDate) : null
      }

      return originalData
    },

    async inspectionMenuItemClick (event) {
      const { menuIndex } = event || {}
      await this.onInspectionReportGenerateDocument(event, menuIndex === 1)
    },

    onUploadDocument (event) {
      const { fetchTabData } = event || {}
      this.$set(this.uploadSignedDocumentDialogConfig, 'showDialog', true)
      if (typeof fetchTabData === 'function') {
        this.$set(this.uploadSignedDocumentDialogConfig.config, 'fetchTabData', async () => {
          fetchTabData()
          await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)
        })
      }
    }
  }
}
